export default __webpack_public_path__ + "static/media/12.46ec40cc.PNG";